interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={`flex flex-col ${isCenter ? "items-center text-center" : "items-start"}`}>
      {eyebrow && (
        <span className="inline-flex items-center gap-2 font-label text-xs md:text-sm tracking-[0.24em] text-primary-600 uppercase">
          <span className="w-6 h-px bg-primary-500" aria-hidden="true" />
          {eyebrow}
        </span>
      )}
      <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 max-w-2xl text-sm md:text-base leading-relaxed text-foreground-600 ${isCenter ? "mx-auto" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}